import { h } from 'preact'
import { useStateValue } from '../../state-management/store'
import { Header } from '../header'
import { BookingStep } from '../../models/enums'

const titles = [
    'Choose a Location',
    'Have you been to this location before?',
    'Patient Information',
    'Additional Information',
    'Select a Date and Time',
    'Please confirm your appointment details',
    'Reserving your spot on the calendar....',
    'Your appointment has NOT been scheduled yet!',
    'Your appointment has been scheduled!',
    'Your appointment has NOT been scheduled!',
]

const SelfSchedulerHeader: preact.FunctionalComponent = () => {
    const [{ bookingStep, hasAdditionalInformation }] = useStateValue()

    const steps = [BookingStep.LOCATION, BookingStep.PATIENT_TYPE, BookingStep.DETAILS, BookingStep.DATETIME]

    if (hasAdditionalInformation) {
        steps.splice(3, 0, BookingStep.ADDITIONAL_INFO)
    }

    return <Header titles={titles} steps={steps} currentStep={bookingStep} />
}

export default SelfSchedulerHeader
